<template>
    <div class="codelinkelement" v-if="column !== undefined && column.length > 0 && code !== undefined && code.length > 0">
        <code-link v-for="codelink in codeLinkArray" :key="codelink" :column="column" :code="codelink" :dependantCode="dependantCode" :index="index"/>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-property-decorator"
    import CodeLink from "./CodeLink.vue"

    @Component({
        components: {
            "code-link": CodeLink
        }
    })
    export default class CodeLinkElement extends Vue {
        @Prop() readonly code: string | undefined
        @Prop() readonly column: string | undefined
        @Prop() readonly dependantCode: string | undefined
        @Prop() readonly index!: string

        get codeLinkArray() {
            return this.code?.split(";")
        }
    }

</script>

<style scoped>
    .codelinkelement {
        display: inline-block;
    }
</style>
